import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { brandName } from "@/lib/brand";

export const regDupMsg = () => `This horse has already been submitted to ${brandName() || "us"}.`;

function Match({ m }) {
  if (m.sign_in_required) return <p className="text-sm mt-1">Sign in to your Seller Portal to view it.</p>;
  return <p data-testid="dup-match-info" className="text-sm mt-1"><strong>{m.name}</strong> · {m.status}</p>;
}

// A registered-name or barn-name match blocks Step 2 until the seller goes to the existing Ad Template or ticks Override.
export function DuplicateNotice({ dup, onOverride }) {
  const navigate = useNavigate();
  const m = dup?.registered || dup?.barn;
  if (!m) return null;
  const on = !!dup.override;
  return (
    <div data-testid="dup-notice" role="alert" className={`rounded-xl border-2 p-4 ${on ? "border-stone-300 bg-stone-50 text-stone-800" : "border-red-300 bg-red-50 text-red-900"}`}>
      <p data-testid="dup-heading" className="font-semibold flex items-start gap-2"><AlertCircle className="h-5 w-5 shrink-0 mt-0.5" />Horse Already Exists</p>
      <p className="text-sm mt-1">{dup.registered ? regDupMsg() : `You already have a horse named ${m.name || "this"} in your account.`}</p>
      <Match m={m} />
      <button type="button" data-testid="dup-view-my-horse" onClick={() => navigate(m.view_path)}
        className="mt-3 w-full sm:w-auto min-h-[48px] px-6 rounded-full bg-stone-900 text-white font-semibold">Go to My Ad Template</button>
      <label className="mt-3 flex items-center gap-2 min-h-[44px] cursor-pointer text-xs text-stone-600">
        <Checkbox data-testid="dup-override" checked={on} onCheckedChange={(v) => onOverride(!!v)} className="h-4 w-4" />
        <span>Override — Submit a New Application</span>
      </label>
    </div>
  );
}
